export const RegularItemKbn = {
  Regular: -1,
  Normal: 0,
} as const

export interface AxeItem {
  itemPageUrl: string | null
  itemPageTitle: string | null
  itemPageThumbnailImage: string | null
  /**
   * id
   */
  itemId: number | string
  itemCd: string
  itemName: string
  mailDeliveryFlag: number
  mailDeliveryPoint: number
  regularItemKbn: number
  changeRegularItemId: number
  /**
   * sku.id
   */
  itemDetailId: number | string
  trialItemDetailId: number | string,
  // 定期コース別のsku_code
  regularItemDetailId: {
    1: string | number,
    2: string | number,
    3: string | number,
  },
  itemDetailName: string
  sellingPrice: number
  sellingPriceNoTax: number
  discountPrice: number
  discountPriceNoTax: number
  startDate: string
  endDate: string
}
